import React, { Component } from 'react'
import 'babel-polyfill'

import checkBrowser from './browserCheck/browserCheck'

import ArForm from './form/form'
import Incompatible from './browserCheck/incompatible'
import Lang from './lang/lang'






function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, "$&")
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent( results[2].replace(/\+/g, " ") );
}


const hasRecoveryParam = getParameterByName('recover')
if ( hasRecoveryParam ) {
  document.body.classList.add( 'recover-page' )
}

let platformVersion = getParameterByName('v')
platformVersion = platformVersion === '3' ? '3' : '4'


class App extends Component {

  constructor() {
    super()
    this.state = {
      texts: {},
      lang: 'ru',
    }
  }


  onLangChange(lang, texts) {
    this.setState({lang:lang,texts: texts})

    if (this.refs.arForm) {
      this.refs.arForm.updateLang(lang, texts)
    }
    else if (this.refs.Incompatible) {
    	this.refs.Incompatible.updateLang(lang, texts)
		}
  }

  render () {

		const tx = this.state.texts
		const recClass = hasRecoveryParam ? ' recover' : ''

		const CN_SPHERE = 'sphere.addreality.cn'
		const FOOTER_TEXT = window.location.host === CN_SPHERE ? `${tx.copy + tx.icp}` : tx.copy

		const isCompatibleBrowser = checkBrowser()

		console.log( window.location )
		
		if ( !isCompatibleBrowser ) {
			return (
				<div className='incompatible_wrapp'>
					<div className='incompatible'>
						<Incompatible
							texts={tx}
							lang={this.props.lang}
							ref="Incompatible"
						/>
						<Lang onLangChange={this.onLangChange.bind(this)}/>
					</div>
			</div>
			);
		}
		
		return (
			<div className="wrp">
				<div className={'main' + recClass}>
					<div className="text">
						<h1 dangerouslySetInnerHTML={{__html: tx.h1}}></h1>
						<p dangerouslySetInnerHTML={{__html: tx.p}}></p>
						<h3>{tx.h3}</h3>
						<ul>
							<li dangerouslySetInnerHTML={{__html: tx.li1}}></li>
							<li dangerouslySetInnerHTML={{__html: tx.li2}}></li>
							<li dangerouslySetInnerHTML={{__html: tx.li3}}></li>
						</ul>
				
					</div>
				
					<ArForm
						texts={tx}
						lang={this.state.lang}
						ref="arForm"
						hasRecoveryParam={hasRecoveryParam}
						platformVersion={platformVersion}
					/>
			
				</div>
				<footer>
					<div className="copy" dangerouslySetInnerHTML={{__html: FOOTER_TEXT}}></div>
					<Lang onLangChange={this.onLangChange.bind(this)}/>
				</footer>
			</div>
		)

	}
}

export default App;






// WEBPACK FOOTER //
// ./src/app.jsx